// INTRO → MAIN
(function () {
  var gate = document.getElementById('intro-gate');
  var main = document.getElementById('mm-main');
  var btn  = document.getElementById('intro-btn');

  if (!gate || !main || !btn) return;

  btn.addEventListener('click', function () {
    gate.classList.add('hidden');
    main.style.display = 'block';
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
})();

// GLÜCKSRAD + TICKET-ABFRAGE
(function () {
  var API_ENDPOINT = 'https://script.google.com/macros/s/AKfycbzYNPIwjzjnprtj6jyTepfDXSGeh0khxlSZRus9TzoEk389c4uQbCcmH0QxzO552BHC/exec';

  function calculateTickets(amount) {
    var a = Number(String(amount).replace(',', '.')) || 0;
    if (a >= 500) return 200;
    if (a >= 200) return 50;
    if (a >= 100) return 30;
    if (a >= 50)  return 10;
    if (a >= 20)  return 4;
    return 0;
  }

  function setMessage (el, text, type) {
    if (!el) return;
    el.textContent = text || '';
    el.className = 'gluecksrad-message' + (type ? ' gluecksrad-message--' + type : '');
  }

  // Popup
  var popupOverlay   = document.getElementById('ticket-popup');
  var popupCloseBtn  = document.getElementById('ticket-popup-close');
  var popupHighlight = document.getElementById('ticket-popup-highlight');
  var popupMeta      = document.getElementById('ticket-popup-meta');

  function openTicketPopup (highlightHtml, metaText) {
    if (!popupOverlay || !popupHighlight || !popupMeta) return;
    popupHighlight.innerHTML = highlightHtml || '';
    popupMeta.textContent    = metaText || '';
    popupOverlay.classList.add('active');
  }
  function closeTicketPopup () {
    if (popupOverlay) popupOverlay.classList.remove('active');
  }
  if (popupCloseBtn) {
    popupCloseBtn.addEventListener('click', closeTicketPopup);
  }
  if (popupOverlay) {
    popupOverlay.addEventListener('click', function (e) {
      if (e.target === popupOverlay) closeTicketPopup();
    });
  }

  // Einzahlung eintragen
  var form          = document.getElementById('gluecksrad-form');
  var msgBox        = document.getElementById('gluecksrad-message');
  var emailInput    = document.getElementById('gr-email');
  var casinoSelect  = document.getElementById('gr-casino');
  var nameInput     = document.getElementById('gr-name');
  var amountInput   = document.getElementById('gr-amount');
  var confirmCheck  = document.getElementById('gr-confirm');

  function handleEntrySubmit(e) {
    e.preventDefault();
    if (!form) return;

    var email   = (emailInput.value   || '').trim();
    var casino  = (casinoSelect.value || '').trim();
    var name    = (nameInput.value    || '').trim();
    var amountS = (amountInput.value  || '').trim();
    var confirmed = !!confirmCheck.checked;
    var amount = Number(amountS.replace(',', '.'));

    if (!email || !casino || !amount) {
      setMessage(msgBox, 'Bitte fülle E-Mail, Casino und Betrag aus.', 'error');
      return;
    }

    var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(email)) {
      setMessage(msgBox, 'Bitte gib eine gültige E-Mail-Adresse ein.', 'error');
      return;
    }

    if (!confirmed) {
      setMessage(msgBox, 'Bitte bestätige, dass du 18+ bist und die Teilnahmebedingungen akzeptierst.', 'error');
      return;
    }

    var tickets = calculateTickets(amount);
    if (tickets === 0) {
      setMessage(
        msgBox,
        'Beträge unter 20 € erzeugen keine Tickets. Bitte erhöhe deinen Betrag.',
        'error'
      );
      return;
    }

    setMessage(msgBox, 'Deine Einzahlung wird gespeichert...', 'info');

    var payload = {
      action:     'add',
      email:      email,
      casino:     casino,
      amount:     amount,
      tickets:    tickets,
      name:       name,
      source:     'nouri-amk-gluecksrad',
      created_at: new Date().toISOString()
    };

    fetch(API_ENDPOINT, {
      method: 'POST',
      body: JSON.stringify(payload)
    })
    .then(function (res) {
      return res.json().catch(function () { return {}; });
    })
    .then(function (data) {
      if (data && data.status === 'success') {
        var highlightHtml =
          'Für diese Einzahlung von <span>' +
          amount.toFixed(2) +
          ' €</span> erhältst du <span>' +
          tickets +
          ' Tickets</span>.';

        var metaText = 'Die Tickets wurden erfolgreich für das Las-Vegas-Giveaway gespeichert.';

        openTicketPopup(highlightHtml, metaText);

        setMessage(
          msgBox,
          'Glückwunsch! Deine Einzahlung wurde gespeichert. Für diese Einzahlung: ' +
          tickets + ' Tickets.',
          'success'
        );
        form.reset();
      } else {
        setMessage(
          msgBox,
          'Ups, da ist etwas schiefgelaufen. Bitte versuche es später erneut oder kontaktiere den Support.',
          'error'
        );
      }
    })
    .catch(function (err) {
      console.error('Fehler beim Senden:', err);
      setMessage(
        msgBox,
        'Ups, da ist etwas schiefgelaufen. Bitte versuche es später erneut oder kontaktiere den Support.',
        'error'
      );
    });
  }

  if (form) {
    form.addEventListener('submit', handleEntrySubmit);
  }

  // Tickets abfragen
  var ticketForm   = document.getElementById('ticket-check-form');
  var ticketMsgBox = document.getElementById('ticket-check-message');
  var tcEmailInput = document.getElementById('tc-email');
  var tcCasinoSel  = document.getElementById('tc-casino');

  function handleTicketCheck (e) {
    e.preventDefault();
    if (!ticketForm) return;

    var email  = (tcEmailInput.value || '').trim();
    var casino = (tcCasinoSel.value  || '').trim();

    if (!email) {
      setMessage(ticketMsgBox, 'Bitte gib deine E-Mail-Adresse ein.', 'error');
      return;
    }
    var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(email)) {
      setMessage(ticketMsgBox, 'Bitte gib eine gültige E-Mail-Adresse ein.', 'error');
      return;
    }

    setMessage(ticketMsgBox, 'Tickets werden abgefragt...', 'info');

    var payload = {
      action: 'check',
      email:  email,
      casino: casino
    };

    fetch(API_ENDPOINT, {
      method: 'POST',
      body: JSON.stringify(payload)
    })
    .then(function (res) { return res.json(); })
    .then(function (data) {
      if (!data || data.status !== 'success') {
        setMessage(ticketMsgBox, 'Konnte keine Ticketdaten finden.', 'error');
        return;
      }

      var totalTickets = Number(data.totalTickets || 0);
      var totalAmount  = Number(data.totalAmount  || 0);
      var entryCount   = Number(data.entryCount   || 0);

      var text = 'Für ' + email;
      if (casino) text += ' bei ' + casino;
      text += ' wurden insgesamt ' + totalTickets +
              ' Tickets und ' + totalAmount.toFixed(2).replace('.', ',') +
              ' € qualifizierende Einzahlungen gespeichert. (' +
              entryCount + ' Einträge)';

      setMessage(ticketMsgBox, text, 'success');

      openTicketPopup(
        'Du hast aktuell <span>' + totalTickets +
        ' Tickets</span> im System.',
        'Gesamte qualifizierende Einzahlungen: ' +
        totalAmount.toFixed(2).replace('.', ',') +
        ' € • Anzahl Einzahlungen: ' + entryCount
      );
    })
    .catch(function (err) {
      console.error('Fehler bei Ticket-Check:', err);
      setMessage(
        ticketMsgBox,
        'Ups, Ticketabfrage aktuell nicht möglich. Bitte später erneut versuchen.',
        'error'
      );
    });
  }

  if (ticketForm) {
    ticketForm.addEventListener('submit', handleTicketCheck);
  }
})();